import { makeStyles } from '@material-ui/core/styles';

// Estilo espelhado de PagamentosRemessas/style.js — mantem largura 78%,
// marginTop 31vh, inputs 44px/16px/uppercase (feedback_capittale_estilizacao).
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '100vh',
    background: '#F2F1F1',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    overflowX: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
  },
  rootForm: {
    display: 'flex',
    flexDirection: 'column',
    width: '78%',
    marginTop: '31vh',
    marginBottom: '3%',
    maxHeight: '57vh !important',
    overflowX: 'hidden',
  },
  label: {
    fontSize: '13px',
    fontWeight: 'bold',
    float: 'left',
    marginBottom: '7px',
    width: '97%',
  },
  input: {
    flex: 1,
    color: '#949494',
    borderWidth: 0,
    height: '44px',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '1%',
    fontSize: '16px',
    opacity: '100%',
    textTransform: 'uppercase',
    outline: 'none',
    borderRadius: '5px',
    background: '#fff',
  },
  medium: {
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    width: '97%',
    backgroundColor: '#FFF',
    marginBottom: '16px',
    color: '#949494',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 600,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: '63px',
    paddingRight: '10px',
    marginBottom: '19px',
  },
  buttonFilter: {
    background: '#026894',
    border: 'none',
    color: '#fff',
    width: '120px',
    height: '36px',
    padding: '0 12px',
    borderRadius: '2px',
    fontWeight: 'bold',
    fontSize: '14px',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:disabled': { background: '#9CB7C4', cursor: 'not-allowed' },
  },
  buttonAction: {
    background: '#026894',
    border: 'none',
    color: '#fff',
    height: '36px',
    padding: '0 16px',
    borderRadius: '2px',
    fontWeight: 'bold',
    fontSize: '14px',
    cursor: 'pointer',
    marginLeft: '10px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:disabled': { background: '#9CB7C4', cursor: 'not-allowed' },
  },
  searchContainer: { alignItems: 'center' },
  item: {},
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 16px',
    background: '#fff',
    borderTop: '1px solid #E0E0E0',
    fontSize: '14px',
  },
  totals: {
    display: 'flex',
    flexDirection: 'column',
    fontWeight: 'bold',
  },
  statusChip: {
    display: 'inline-block',
    padding: '3px 10px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#fff',
    whiteSpace: 'nowrap',
  },
  tipoChip: {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: '10px',
    fontSize: '11px',
    fontWeight: 'bold',
    color: '#fff',
    background: '#546E7A',
    whiteSpace: 'nowrap',
  },
  origemChip: {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: '10px',
    fontSize: '11px',
    fontWeight: 'bold',
    color: '#455A64',
    background: '#ECEFF1',
    whiteSpace: 'nowrap',
  },
  errorLink: {
    color: '#C62828',
    textDecoration: 'underline',
    cursor: 'pointer',
    fontSize: '13px',
  },
  linkCell: {
    color: '#026894',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  autoRefreshBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    background: '#FFF3E0',
    color: '#E65100',
    padding: '4px 10px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: 'bold',
    marginLeft: '12px',
  },
  modalBody: {
    minWidth: '520px',
    padding: '16px',
  },
  modalRow: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '6px 0',
    fontSize: '14px',
    gap: '12px',
  },
  modalLabel: { fontWeight: 'bold', minWidth: '160px' },
  modalPre: {
    background: '#F5F5F5',
    padding: '10px',
    borderRadius: '4px',
    fontFamily: 'monospace',
    fontSize: '12px',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    maxHeight: '260px',
    overflow: 'auto',
    marginTop: '4px',
  },
}));

export default useStyles;
